<template>
  <el-container  style="display: block;">

    <el-row  class="tui-el"  style="margin-top: 20px;margin-left: 3%;">


        <el-row :span="2" style="margin-top: 30px;">


            <el-button type="primary" style="background-color: #409eff;" @click="add()" round>添加</el-button>
        </el-row>
        <el-row  class="elementsz" style="margin-top: 30px;">
          <template>
            <el-table
          	:data="list"
            height="1000"
          	border
          	style="width: 95%;margin-left: 0;height: 800px;text-align: center;">
            <el-table-column

              width="500"
              label="Appid"
               >
               <template slot-scope="scope">
                   <div>{{scope.row.appid}}</div>
               </template>
            </el-table-column>

            <el-table-column

              width="200"
              label="查看"
               >
               <template slot-scope="scope">
                 <div><el-button type="primary" style="background-color: #409eff;" @click="sets(scope.row.id)" round>查看</el-button></div>
               </template>
            </el-table-column>
            <el-table-column

              width="300"
              label="设置"
               >
               <template slot-scope="scope">
                   <div><el-button type="primary" style="background-color: #409eff;" @click="reset(scope.row.id,scope.row.appid)" round>设置</el-button></div>
               </template>
            </el-table-column>
            <el-table-column

              width="200"
              label="删除"
               >
               <template slot-scope="scope">
                 <el-row>
                   <el-col :span="8" style="text-align: center;margin-top: 15px;" @click.native="del(scope.row.id)">删除</el-col>
                   <!-- <el-col :span="4" style="text-align: center;margin-top: 15px;">更新</el-col> -->
                 </el-row>
               </template>
            </el-table-column>

            </el-table>
          </template>
          <div class="page">
          	<el-pagination
          	  @size-change="loadList()"
          	  @current-change="loadList()"
          	  :current-page.sync="page"
          	  :page-size="15"
          	  background
          	  layout="total,prev, pager, next, jumper"
          	  :total="count">
          	</el-pagination>
          </div>
        </el-row>






    </el-row>


    <el-drawer
      title="添加"
      :visible.sync="addVisible"
      :with-header="false">
      <el-input v-model="appid" style="width: 300px;margin-bottom: 30px;" placeholder="请输入appid"></el-input>
      <el-transfer v-model="value" :data="data" style="margin-bottom: 30px;"></el-transfer>
      <!-- <el-button @click="addVisible = false">取 消</el-button>
      <el-button type="primary" @click="dochangexiaoguo()">确 定</el-button> -->
      <span class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="doAdd()">确 定</el-button>
      </span>
    </el-drawer>

    <!-- <el-drawer
      title="查看"
      :visible.sync="setVisible"
      :with-header="false">
      <el-col :span="18" style="border: 1px solid #c6c6c6;height: 850px;overflow-y:scroll;width: 60%;margin-top: 10px;">


        <el-row  class="tui-el" style="margin-bottom: 20px;">
          <el-col :span="6" style="text-align: center;">功能</el-col>



        </el-row>

        <el-row  class="tui-el" v-for="(item,index) in lists" :key="index" >
          <el-col :span="6" style="text-align: center;line-height: 60px;">{{item.name}}</el-col>


        </el-row>
      </el-col>

    </el-drawer> -->


    <el-dialog
      title="查看"
      :visible.sync="setVisible"
      width="30%"

      center>
      <el-row style="border: 1px solid #c6c6c6;height: 450px;overflow-y:scroll;width: 60%;margin-top: 10px;">
        <el-col :span="20" >
          <el-row  class="tui-el" style="margin-bottom: 20px;">
            <el-col :span="20" style="text-align: center;color: red;">禁用的兜底列表</el-col>
          </el-row>
          <el-row  class="tui-el" v-for="(item,index) in lists" :key="index" >
            <el-col :span="20" style="text-align: center;line-height: 60px;">{{item.name}}</el-col>
          </el-row>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
    	<el-button @click="setVisible = false">取 消</el-button>
    	<el-button type="primary" @click="dochange()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<script>
  export default {
    data() {

       return {
         appid:'',
         data: [],
         value: [],
         page:1,
         count:0,
         list:[],
         addVisible:false,
         setVisible:false,
         seeVisible:false,
         glist:[],
         lists:[],
         aid:0,
         addT:'',
         id:0,
         centerDialogVisible:false,



      }
    },
  directives: {
    },
    created() {
      this.loadList();

    },

  methods:{
    reset(id,appid){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          appid:appid
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/appiddouset'
      })
      .then(res=>{
      	if(res.data.code == 200){

           this.$message({
           	type: 'success',
           	message: '操作成功'
           });

      	}else{

      	}

      })
      .catch(err=>{

      });
    },
    dochange(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });


      axiosInstance({
      	method:'post',
      	params:{
      		id:this.id,
          name:this.addT,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/appiddouChange'
      })
      .then(res=>{
      	if(res.data.code == 200){
           this.centerDialogVisible = false
           this.$message({
           	type: 'success',
           	message: '操作成功'
           });
           this.sets(this.aid)
      	}else{

      	}

      })
      .catch(err=>{

      });
    },
    change(name,id){
      this.addT = name
      this.id = id
      this.centerDialogVisible = true
    },
    sets(id){
      this.aid = id
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          id:id,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/appiddoulists'
      })
      .then(res=>{

        this.lists = res.data.data;
        this.setVisible = true

      })
      .catch(err=>{

      });
    },
    see(id){
      this.aid = id
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          id:id,
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/appiddoulists'
      })
      .then(res=>{

        this.lists = res.data.data;
        this.seeVisible = true

      })
      .catch(err=>{

      });
    },
    doAdd(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          appid:this.appid,
          list:this.value.join(',')
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/appiddouAdd'
      })
      .then(res=>{
        this.$message({
        	type: 'success',
        	message: '添加成功'
        });
        this.loadList();
        this.addVisible = false


      })
      .catch(err=>{

      });
    },
    add(){
      // this.drawer = true
      this.addVisible = true
      this.data = []
      const that = this
      this.glist.forEach((item, index) => {
        that.data.push({
          label: item['name'],
          key: item['ci'],

        });
      });
    },

    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:this.seachName,
          p:this.page,
          lid:this.seachLid,
          t:this.fenzu
      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/appiddouList'
      })
      .then(res=>{

        this.list = res.data.data;
        this.count = res.data.count;
        this.glist = res.data.list;


      })
      .catch(err=>{

      });
    },
    del(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:id

      	},
      	url:'http://y31p.yoooooo.com/index.php/index/data/appiddouDel'
      })
      .then(res=>{
      	this.$message({
      		type: 'success',
      		message: '删除成功'
      	});
        this.loadList();
      })
      .catch(err=>{

      });
    },



    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

  }


  }
</script>

<style>
  .el-transfer-panel__list{
    height: 800px;
  }
  .el-transfer-panel__body{
    height: 800px;
  }
  .el-transfer-panel__body{
    height: 800px;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/appiddou.vue